import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-widget-device',
  templateUrl: './widget-device.component.html',
  styleUrls: ['./widget-device.component.scss'],
})
export class WidgetDeviceComponent {
  @Input() public isMobile: boolean;
  @Input() public widgetData: any;
  @Input() public route: string = 'home';
  constructor(
  ) {
  }
}
